import { Image } from '@wix/image';

export default Image;
